"use client";
import * as React from "react";
import { fetchMe } from "./session";
import { redirectToLogin } from "./redirect";
import type { AuthUser } from "./types";

type Status = "loading" | "ok" | "redirecting";

export const RequireAuth: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [status, setStatus] = React.useState<Status>("loading");

  React.useEffect(() => {
    fetchMe().then((u) => {
      if (!u) {
        setStatus("redirecting");
        redirectToLogin();
      } else {
        setStatus("ok");
      }
    });
  }, []);

  if (status === "loading" || status === "redirecting") {
    // Tih fallback — SecurityCheck (post-login) je već uradio interstitial,
    // ovdje ne smijemo prikazati drugu "Provjera..." stranicu (Velibor: jedna).
    return null;
  }
  return <>{children}</>;
};

export const RequireSuperAdmin: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [user, setUser] = React.useState<AuthUser | null | undefined>(undefined);

  React.useEffect(() => {
    fetchMe().then(setUser);
  }, []);

  if (user === undefined) {
    // Tih fallback — vidi RequireAuth komentar.
    return null;
  }
  if (user === null) {
    redirectToLogin();
    return null;
  }
  if (!user.is_superuser) {
    // Velibor: tenant user nije super_admin — redirect na ERP (njegova glavna
    // aplikacija) umjesto plain text "Pristup zabranjen".
    if (typeof window !== "undefined") {
      const isDev = window.location.hostname.endsWith(".dev.grozd.me");
      const erpUrl = isDev ? "https://erp.dev.grozd.me" : "https://erp.grozd.me";
      window.location.href = erpUrl;
    }
    return null;
  }
  return <>{children}</>;
};
